import { render } from "./TariffsView.vue?vue&type=template&id=be09be4a&scoped=true"
import script from "./TariffsView.vue?vue&type=script&lang=js"
export * from "./TariffsView.vue?vue&type=script&lang=js"

import "./TariffsView.vue?vue&type=style&index=0&id=be09be4a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be09be4a"]])

export default __exports__